import { IApplicationContext } from 'shared/types/applicationContext';
import { TAdditionalFormParams } from 'shared/types/form';
import { TSendFormResponse } from './types';

export async function fetchAdditionalForm(
  { httpApi }: IApplicationContext,
  params: TAdditionalFormParams,
): Promise<TSendFormResponse> {
  const { response, statusCode } = await httpApi.fetch(
    {
      apiType: 'external',
      microserviceName: 'info-api',
      assertStatusCodes: [200, 400],
      method: 'POST',
      pathApi: '/api/pik/v1/save-additional-form-request',
      requestContentType: 'json',
      parameters: { ...params },
    },
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
    },
  );

  return { statusCode, response } as TSendFormResponse;
}
